import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ImportHome from './ImportHome/ImportHome';
import CreateCSV from './CreateCSV/CreateCSV';
import { CSVContextProvider } from '../../../../Context/CSVContext';
import { CSVUploadContextProvider } from '../../../../Context/CSVUploadContext';
import UploadCSV from './UploadCSV';
import DeleteConfirmation from './DeleteConfirmation';
import SelectCategory from './SelectCategory';
import HideConfirmation from './HideConfirmation';
import ProductOrganisation from './ProductOrganisation/ProductOrganisation';
import AddTags from './AddTags';
import EditProductStock from './EditProductStock';
import BulkUpdateHome from './BulkUpdate/BulkUpdateHome';
import SelectSizeChart from './SelectSizeChart';
import UpdateSizeChart from './UpdateSizeChart';
import SelectVariantToEdit from './SelectVariantToEdit';

function Modal() {
    const [visible, setVisible] = useState(false);
    const activeModal = useSelector((state) => state.inventoryManagement.modal.activeModal);
    const displayModal = useSelector((state) => state.inventoryManagement.modal.displayModal);

    useEffect(() => {
        if(displayModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayModal]);

    return (
        <CSVUploadContextProvider>
            <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 w-full h-full top-0 left-0 flex justify-center items-center`}>
                {activeModal === 'import-home' && <ImportHome />}

                {
                    activeModal === 'create-csv' && 
                    <CSVContextProvider>
                        <CreateCSV />
                    </CSVContextProvider>
                }

                {activeModal === 'upload-csv' && <UploadCSV />}

                {activeModal === 'delete-confirm' && <DeleteConfirmation />}

                {activeModal === 'hide-confirm' && <HideConfirmation />}

                {activeModal === 'add-product-select' && <SelectCategory />}

                {activeModal === 'add-product-org' && <ProductOrganisation />}

                {activeModal === 'add-tags' && <AddTags />}

                {activeModal === 'edit-product-stock' && <EditProductStock />}

                {activeModal === 'bulk-update-home' && <BulkUpdateHome />}

                {activeModal === 'select-size-chart' && <SelectSizeChart />}

                {activeModal === 'update-size-chart' && <UpdateSizeChart />}

                {activeModal === 'select-variant-to-edit' && <SelectVariantToEdit />}
            </div>
        </CSVUploadContextProvider>
    );
}

export default Modal;
